<template>
    <div>
        <!-- Dynamic Title -->
        <h3 v-if="label" class="font-bold text-won-green text-base leading-5">
            {{ label }}
        </h3>

        <!-- Progress Bar -->
        <div :class="['relative w-full bg-won-sand-light rounded-full h-1.5', label ? 'mt-1.5' : '']">
            <!-- Progress Bar Fill -->
            <div
                :class="[currentStepIndex + 1 === steps?.length ? 'rounded-r-full' : '']"
                :style="greenFillStyle"
                class="absolute top-0 left-0 h-1.5 bg-won-green rounded-l-full"
            ></div>

            <div
                v-if="viewingStepIndex < currentStepIndex"
                :class="[
                    viewingStepIndex + 1 === steps?.length ? 'rounded-r-full' : '',
                    viewingStepIndex === 0 ? 'rounded-l-full' : '',
                ]"
                :style="overlayStyle"
                class="absolute top-0 h-1.5 bg-white/60"
            ></div>

            <div
                v-else-if="viewingStepIndex > currentStepIndex"
                :class="[
                    viewingStepIndex + 1 === steps?.length ? 'rounded-r-full' : '',
                    viewingStepIndex === 0 ? 'rounded-l-full' : '',
                ]"
                :style="overlayStyle"
                class="absolute top-0 h-1.5 bg-won-gray/60"
            ></div>

            <!-- Tick Marks -->
            <div class="absolute top-0 left-0 w-full h-1.5 flex place-content-evenly">
                <div
                    v-for="(_, index) in steps?.length - 1"
                    :key="index"
                    class="w-px h-full bg-won-gray-light"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, toRefs, computed } from "vue";

const props = defineProps({
    steps: {
        type: Array,
        required: true,
    },
    viewingStepIndex: {
        type: Number,
    },
    currentStepIndex: {
        type: Number,
        required: true
    },
    label: {
        type: String,
        default: "",
    },
});

const { steps, viewingStepIndex, currentStepIndex } = toRefs(props);


const greenFillStyle = computed(() => {
    const pct = ((currentStepIndex.value + 1) / steps.value.length) * 100;
    return `width: ${pct}%;`;
});

const isStepPassed = () => {
    return viewingStepIndex.value > currentStepIndex.value;
};

const overlayStyle = computed(() => {
    const stepWidth = isStepPassed()
        ? ((viewingStepIndex.value - currentStepIndex.value) / steps.value.length) * 100
        : (1 / steps.value.length) * 100;
    const left = isStepPassed()
        ? ((currentStepIndex.value + 1) / steps.value.length) * 100
        : (viewingStepIndex.value / steps.value.length) * 100;

    return `
        left: ${left}%;
        width: ${stepWidth}%;
    `;
});
</script>
